// @flow

import Unit from '@/lib/unit';
import Condition from '@/lib/condition';

export default class {
  static process(unit: Unit) {
    if (!unit.template.effects) return;

    for (let i = 0; i < unit.template.effects.length; i++) {
      const effect = unit.template.effects[i];

      // 条件がある場合は検証（その場合、全て満たす必要がある）
      let isSatisfy = true;

      if (typeof effect.conditions !== 'undefined') {
        for (let j = 0; j < effect.conditions.length; j++) {
          const condition = effect.conditions[j];
          const value = unit.getParameter(condition[0], condition[1]);

          if (!new Condition(condition[2]).judge(value)) {
            isSatisfy = false;
            break;
          }
        }
      }

      if (isSatisfy) {
        unit.cell.update(effect.type, effect.value, effect.range);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/unit_event/affect_event.js